import React from 'react';
import Dashboard from './Dashboard';
import "nexus-common/styles/index.less";
import PageBase from './access/PageBase';

export default class DashboardHome extends PageBase {
    constructor(props: any) {
        super(props);

        this.state = {};
    }

    renderPage() {
        return <Dashboard
            currentUser={this.props.currentUser}
            logoutHandler={this.props.logoutHandler}  
        />;
    }
}
